import {css} from "styled-components";

export const SubmitFooterStyle = css`
  /* Other */
  .transaction-button-row {
    margin-top: 16px;

    /* added v4 version */
    .ant-row.ant-legacy-form-item {
      margin-bottom: 0;

      .ant-legacy-form-item-control {
        line-height: 32px;
      }
    }

    .ant-row.ant-form-item {
      margin-bottom: 0;

      .ant-form-item-control {
        line-height: 32px;
      }
    }
  }

  .no-margin-top {
    .transaction-button-row {
      margin-top: 0;
    }
  }
  
  
  .content-menu-row {
    margin-bottom: 16px;
    text-align: right;

    &.has-top-margin {
      margin-top: 16px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

`;
